import moment from "moment";
import Service from "../../services";

const Basket = {
    namespaced: true,
    state: {
        order_type: null,
        basket: null,
        groupBasket: null,
        address: null,
        shipping_address: null,
        recipient: null,
        datetime: null,
        shop: null,
        payment: null,
        reward: null,
        remark: null,
        promocode : null
    },
    mutations: {
        SET_ORDER_TYPE: (state, data) => {
            state.order_type = data
        },
        SET_ADDRESS: (state, data) => {
            state.address = data
        },
        SET_SHIPPING_ADDRESS: (state, data) => {
            state.shipping_address = data
        },
        SET_RECIPIENT: (state, data) => {
            state.recipient = data
        },
        SET_BASKET: (state, data) => {
            state.basket = data
        },
        SET_GROUP_BASKET: (state, data) => {
            state.groupBasket = data
        },
        SET_DATETIME: (state, data) => {
            state.datetime = data
        },
        SET_SHOP: (state, data) => {
            state.shop = data
        },
        SET_PAYMENT: (state, data) => {
            state.payment = data
        },
        SET_REWARD: (state, data) => {
            state.reward = data
        },
        SET_REMARK: (state, data) => {
            state.remark = data
        },
        SET_PROMOCODE: (state, data) => {
            state.promocode = data
        },
        CLEAR_BASKET: (state) => {
            state.basket = null
        },
        CLEAR_PROMOCODE: (state) => {
            state.promocode = null
        },
    },
    actions: {
        setOrderType({
            commit
        }, data) {
            commit('SET_ORDER_TYPE', data)
            return data
        },
        setAddress({
            commit
        }, data) {
            commit('SET_ADDRESS', data)
        },
        setShippingAddress({
            commit
        }, data) {
            let shipping_address = {
                address: data.address,
                postcode: data.postcode,
                province: data.province,
                district: data.district,
                sub_district: data.sub_district,
            }
            commit('SET_SHIPPING_ADDRESS', shipping_address)
            return
        },
        setRecipient({
            commit
        }, data) {
            commit('SET_RECIPIENT', data)
        },
        setDatetime({
            commit
        }, data) {
            commit('SET_DATETIME', data)
            return data
        },
        setShop({
            commit
        }, data) {
            commit('SET_SHOP', data)
        },
        setPromocode({
            commit
        }, data) {
            commit('SET_PROMOCODE', data)
            return true
        },
        setPayment({
            commit
        }, data) {
            commit('SET_PAYMENT', data)
        },
        setReward({
            commit
        }, data) {
            commit('SET_REWARD', data)
            return true
        },
        setRemark({
            commit
        }, data) {
            commit('SET_REMARK', data)
            return true
        },
        clearBasket({
            commit
        }) {
            commit('CLEAR_BASKET')
        },
        reset({
            commit
        }) {
            commit('CLEAR_BASKET')
            commit('CLEAR_PROMOCODE')
            commit('SET_DATETIME', null)
        },
        setBasket({
            state,
            commit
        }, data) {
            
            let basket = state.basket;

            if (basket == null) {
                let b = { shop_id: data.shop_id, items: [] };
                b.items.push(data);
                basket = b;
                commit('SET_BASKET', basket)
                return;
            } else {
                /* REMOVE PRODUCT FROM BASKET */
                if (data.quantity < 1) {
                    //let itemId = data.code.split("?");
                    let itemId = data.code
                    let activeItems = [];
                    basket.items.map(item => {
                        if (item.code != itemId) {
                            activeItems.push(item)
                        }
                    });
                    basket.items = activeItems
                    commit('SET_BASKET', basket)
                    return;
                }

                let index = basket.items.findIndex(
                    x => x.code == data.code
                );

                if (index < 0) {
                    basket.items.push(data);
                    commit('SET_BASKET', basket)
                    return;
                } else {

                    if (data.code) {
                        let basketCode = basket.items[index].code.split("?");
                        let itemCode = data.code.split("?");

                        if (basketCode[1] == '') {
                            basket.items[index].quantity = data.quantity;
                            basket.items[index].remark = data.remark
                            commit('SET_BASKET', basket)
                                //console.log("more item without modifiers!");
                            return;
                        }
                        if (basketCode[1] === itemCode[1]) {
                            basket.items[index].quantity += data.quantity;
                            commit('SET_BASKET', basket)
                                //console.log("more item with modifiers!");
                        } else {
                            basket.items.push(data);
                            commit('SET_BASKET', basket)
                                //console.log("new item with modifiers!");
                        }
                        //this.verifyBasket();
                        return;
                    }

                    let activeItems = [];
                    basket.items.map(item => {
                        if (item.quantity >= 1) {
                            activeItems.push(item)
                        }
                    })
                    basket.items = activeItems
                    commit('SET_BASKET', basket)
                        //this.verifyBasket();
                    return;
                    /*
                    basket.items[index].quantity = data.quantity;
                    basket.items[index].modifiers = data.modifiers;
                    this.storage.set(this.appConfig.myBasketKeyName, basket);
                    */
                    //console.log("exist in basket!");
                }
            }
            return true
            //commit('SET_BASKET', data)
        },
        removeItem({
            state,
            commit
        }, data) {
            let basket = state.basket;
            let itemId = data.code
            let activeItems = [];
            basket.items.map(item => {
                if (item.code != itemId) {
                    activeItems.push(item)
                }
            });
            basket.items = activeItems
            commit('SET_BASKET', basket)
            return;
        },
        removeAllItem({
            state,
            commit
        }, data) {
            commit('SET_BASKET', null)
            return;
        },
        validateBasket({
            state
        }) {

            let userSelectedDate = null

            if (state.order_type == 'commerce') {
                userSelectedDate = null
            } else if (['pickup', 'delivery'].includes(state.order_type)) {
                userSelectedDate = moment(
                    state.datetime.date + ' ' + state.datetime.time,
                    "DD-MM-YYYY HH:mm"
                );
            } else {
                userSelectedDate = moment(
                    new Date(),
                    "DD-MM-YYYY HH:mm"
                );
                userSelectedDate.add(40, "minute")
            }

            let from = null
            let to = null
            let special_requests = ["LALABAG"];
            let order_type = state.order_type

            if (order_type != null) {
                if (order_type == 'delivery') {
                    if (state.payment.value == 'cash') {
                        special_requests.push("HELP_BUY")
                    }

                    from = {
                        location: {
                            lat: state.shop.latitude + '',
                            lng: state.shop.longitude + '',
                        },
                        addresses: {
                            en_TH: {
                                displayString: "120 Sathon Nuea Rd",
                                country: "TH"
                            }
                        }
                    }
                    to = {
                        location: {
                            lat: state.address.address.coords.lat + '',
                            lng: state.address.address.coords.lng + '',
                        },
                        addresses: {
                            en_TH: {
                                displayString: state.address.name,
                                country: "TH"
                            }
                        }
                    }
                } else {
                    order_type = state.order_type
                }
            } else {
                order_type = state.order_type
            }

            let promocode = ""
            if (state.promocode != null) {
                promocode = state.promocode
            }

            let data = {
                order_type: order_type,
                special_requests: special_requests,
                schedule_at: userSelectedDate,
                datetime_type: state.datetime.type,
                stops: [from, to],
                shop_id: state.basket.shop_id,
                basket: state.basket.items,
                payment_type: state.payment.value,
                channel: "liff",
                promocode: {
                    value: promocode
                }
            }

            if (order_type == 'commerce') {
                if(state.shipping_address!=null){
                    data.postcode = state.shipping_address.postcode
                }
            }
            return Service.Order.basket(data).then(res => {
                return res
            }).catch(e => {
                return { error : true }
            })
        }
    }
}
export default Basket